<template>
    <div class="container">
        <order-list :orders="newOrders"></order-list>
    </div>
</template>

<script>
    import {mapGetters} from "vuex"
    export default {
        name: 'new-orders',
        data() {
            return {}
        },
        computed: Object.assign({}, mapGetters(['newOrders'])),
    };
</script>



// WEBPACK FOOTER //
// NewOrders.vue?236ffa03